<template>
  <div>
    <Modal
      title="添加征稿采编"
      width="900"
      :value="showManuscript"
      :mask-closable="false"
      :footer-hide="true"
      @on-visible-change="visibleChange"
    >
      <Input
        style="width: 30%; margin-bottom: 20px"
        size="large"
        placeholder="请输入采编名称"
        search
        @on-search="search"
      />
      <Table
        ref="tabRef"
        :columns="columns"
        :data="tableList"
        @on-select="onSelect"
        @on-select-cancel="onSelectC"
        @on-select-all="OnSelectAll"
        @on-select-all-cancel="onSelectAllC"
        no-data-text="合作期刊下无征稿采编"
      >
        <template slot-scope="{ row }" slot="editType">
          <div>{{row.editType === 1 ? '采编' : row.editType === 2 ? '组稿人' : ''}}</div>
        </template>
      </Table>
      <Page
        style="text-align: center; margin: 30px 0"
        :total="total"
        :current="params.pageNo"
        :page-size="5"
        show-total
        @on-change="pageChange"
      >
        共 {{ total }} 个
      </Page>
      <div style="text-align: center">
        <Button
          type="primary"
          size="large"
          @click="$emit('visibleChange', isSelectList)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    periodicals: {
      type: Array,
    },
    isArr: {
      type: Array,
    },
    showManuscript: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "所属期刊",
          key: "perName",
          ellipsis: "true",
          tooltip: "true",
        },
        {
          title: "职务",
          key: "post",
        },
        {
          title: "类型",
          slot: "editType",
        },
        {
          title: "联系方式",
          key: "phone",
        },
      ],
      tableList: [],
      isSelectList: [],
      total: 0,
      params: {
        editName: "",
        pageNo: 1,
        pageSize: 5,
        perIds: [],
      },
    };
  },
  methods: {
    visibleChange(query) {
      if (query) {
        this.isSelectList = [...this.isArr];
        this.params.perIds = this.periodicals.map((item) => item.perId);
        this.params.perIds = this.params.perIds.filter(
          (item) => item !== "" && item !== null
        );
        this.getTableList();
      } else {
        this.$emit("visibleChange");
      }
    },
    onSelect(selection, row) {
      this.isSelectList.push({ ...row, userName: row.name });
    },
    onSelectC(selection, row) {
      this.isSelectList = this.isSelectList.filter(
        (item) => `${item.userId}${item.perId}` !== `${row.userId}${row.perId}`
      );
    },
    OnSelectAll(selection) {
      selection.forEach((item) => {
        if (
          !this.isSelectList.some(
            (i) => `${i.userId}${i.perId}` === `${item.userId}${item.perId}`
          )
        ) {
          this.isSelectList.push({ ...item, userName: item.name });
        }
      });
    },
    onSelectAllC() {
      this.tableList.forEach((item) => {
        this.isSelectList = this.isSelectList.filter(
          (i) => `${i.userId}${i.perId}` !== `${item.userId}${item.perId}`
        );
      });
    },
    checked() {
      let objData = this.$refs.tabRef.objData; //拿到当前table的值
      for (let index in objData) {
        if (
          this.isSelectList.some((item) => {
            return (
              `${item.userId}${item.perId}` ===
              `${objData[index].userId}${objData[index].perId}`
            );
          })
        ) {
          objData[index]._isChecked = true; //重新勾选
        }
      }
    },
    search(query) {
      this.params.editName = query;
      this.getTableList();
    },
    pageChange(page) {
      this.params.pageNo = page;
      this.getTableList();
    },
    async getTableList() {
      if (this.params.perIds.length === 0) {
        this.tableList = [];
        this.total = 0;
      } else {
        const res = await this.$apis.userServe.meetingEditPage(this.params);
        this.tableList = res.data.list;
        this.total = +res.data.total;
        this.$nextTick(() => {
          this.checked();
        });
      }
    },
  },
};
</script>

<style>
</style>